export const loginRedirectUrl = "/login/?next=";
export const logOutRedirectUrl = "/logout/";

export const servicesUrl = "/api/v1/geoservices/";

export const configUrl = "/api/config";

export const getTermsUrl = (lang: string) => {
  if (lang === "ru") {
    return "https://nextgis.ru/terms/";
  } else {
    return "https://nextgis.com/terms/";
  }
};

export const getConfUrl = (lang: string) => {
  if (lang === "ru") {
    return "https://nextgis.ru/privacy";
  } else {
    return "https://nextgis.com/privacy";
  }
};

export function getLoginRedirectUrl(backRoute: string = "/") {
  return window.location.origin + loginRedirectUrl + backRoute;
}
export function getLogoutRedirectUrl() {
  return window.location.origin + logOutRedirectUrl;
}
